module.exports = __webpack_public_path__ + "img/aelita.23bf11d1.jpg";